$(document).ready(function () {

    $('.frame-type-maloamcherezo_specificdonationwrapper').each(function() {
        specificDonationWrapper = $(this);

        specificDonationWrapper.children('.frame-type-maloamcherezo_specificdonation').each(function (key) {
            specificDonation = $(this).children('.specific-donation').first();
            if (specificDonation.data('purpose') == '') {
                return;
            }

            specificDonationWrapper.children('.purpose-selector').append($('<option>', {
                value: $(this).attr('id'),
                text: specificDonation.data('purpose')
            }));

            if (key === 0) {
                return;
            }

            $(this).hide();
        });

        specificDonationWrapper.children('.purpose-selector').change(function() {
            if ($(this).val() == '') {
                specificDonationWrapper.children('.frame-type-maloamcherezo_specificdonation').hide();
                specificDonationWrapper.children('.frame-type-maloamcherezo_specificdonation').first().show();

                return;
            }

            specificDonationWrapper.children('.frame-type-maloamcherezo_specificdonation').hide();
            specificDonationWrapper.children('#' + $(this).val() + '.frame-type-maloamcherezo_specificdonation').show();
        });
    });
});

$(document).ready(function () {

    $.extend(true, $.magnificPopup.defaults, {
        tClose: 'Schließen (Esc)',
        tLoading: 'Laden...',
        gallery: {
            tPrev: 'Zurück (linke Pfeil-Taste)',
            tNext: 'Weiter (rechte Pfeil-Taste)',
            tCounter: '%curr% von %total%'
        },
        image: {
            tError: '<a href="%url%">Das Bild</a> konnte nicht geladen werden.'
        },
        ajax: {
            tError: '<a href="%url%">Der Inhalt</a> konnte nicht geladen werden.'
        }
    });

    $('.slick-image-slider').slick({
        arrows: true,
    });

    $('.images').each(function () { // the containers for all your galleries
        $(this).magnificPopup({
            delegate: '.lightbox',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });

    function toggleDropdown(e) {
        const _d = $(e.target).closest('.dropdown'),
            _m = $('.dropdown-menu', _d);
        setTimeout(function () {
            const shouldOpen = e.type !== 'click' && _d.is(':hover');
            _m.toggleClass('show', shouldOpen);
            _d.toggleClass('show', shouldOpen);
            $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
        }, e.type === 'mouseleave' ? 300 : 0);
    }

    $('body')
        .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
        .on('click', '.dropdown-menu a', toggleDropdown)
        .on('touchend', 'a.dropdown-toggle', function (e) {
            if ($(this).parent().hasClass('show') && $(this).next('.dropdown-menu').hasClass('show')) {
                window.open($(this).attr('href'), '_self');
                return;
            }
            $(this).parent().addClass('show');
            $(this).next('.dropdown-menu').addClass('show');
            var dropDown = $(this);

            setTimeout(function () {
                dropDown.parent().removeClass('show');
                dropDown.next('.dropdown-menu').removeClass('show');
            }, 3000);

            e.preventDefault();
        })
        .on('click', 'a.dropdown-toggle', function () {
            window.open($(this).attr('href'), '_self');
        });

    var parentWidth = $('.youtube-iframe').parent().width();
    $('.youtube-iframe').width(parentWidth);
    $('.youtube-iframe').height(parentWidth / 16 * 9);

    var hamburger = document.querySelector(".hamburger");
    hamburger.addEventListener("click", function () {
        hamburger.classList.toggle("is-active");
    });

    if ($(window).width() <= 768) {
        $('.dropdown-menu.add-show-class').addClass('show');
    }

    $('.nav-link.dropdown-toggle').click(function (e) {
        if (window.innerWidth < 992) {
            $(this).dropdown('update');
            return false;
        }
    });

    // image pagination
    $('.image-pagination-data').each(function () {
        var contentElementId = $(this).data('content-element-id');
        var dataSource = [];
        $('.data-source-' + contentElementId).each(function () {
            dataSource.push({
                srcLightbox: $(this).data('lightbox'),
                srcSmall: $(this).data('small'),
                title: $(this).data('title'),
                alternative: $(this).data('alternative'),
            });
        });

        $('#image-pagination-' + contentElementId).pagination({
            dataSource: dataSource,
            pageSize: 16,
            className: 'f3-widget-paginator pagination',
            callback: function (data, pagination) {
                var html = template(data);
                $('#image-container-' + contentElementId).html(html);
            }
        })

        function template(dataArray) {
            var template = "";
            $.each(dataArray, function (index, data) {
                template += '<div class="card image-card rounded-0 border-right-0 border-left-0 border-top-0">\n' +
                    '            <a class="lightbox" href="' + data.srcLightbox + '">\n' +
                    '                <img src="' + data.srcSmall + '"\n' +
                    '                     title="' + data.title + '" alt="' + data.alternative + '" class="card-img-top rounded-0"/>\n' +
                    '            </a>\n' +
                    '        </div>';
            });

            return template;

        }
    });

    // donation accordion
    $('.donation-accordion').click(function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });

});
$(document).ready(function () {
    $('.project-charts').each(function() {

        $(this).highcharts({
            chart: {
                type: 'bar'
            },
            title: {
                text: null
            },
            xAxis: {
                categories: [$(this).data('first_chart_text'), $(this).data('second_chart_text')],
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return this.value + '%';
                    },
                    align: 'right'
                },
                min: 0,
                max: 100,
                title: {
                    enabled: false
                }
            },
            exporting: {
                enabled: false
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            tooltip: {
                formatter: function () {
                    return '<strong>' + this.x + ': ' + this.y + '%</strong>';
                }
            },
            series: [{
                data: [{
                    name: $(this).data('first_chart_text'),
                    color: {
                        linearGradient: {
                            x1: 0,
                            x2: 0,
                            y1: 0,
                            y2: 1
                        },
                        stops: getStops($(this).data('first_chart_progress') / 100)
                    },
                    y: $(this).data('first_chart_progress')
                }, {
                    name: $(this).data('second_chart_text'),
                    color: {
                        linearGradient: {
                            x1: 0,
                            x2: 0,
                            y1: 0,
                            y2: 1
                        },
                        stops: getStops($(this).data('second_chart_progress') / 100)
                    },
                    y: $(this).data('second_chart_progress')
                }]
            }]
        });

    });
});

var getStops = function(percentage) {

    var step =  Math.round(1 / percentage * 100) / 10000;

    var colors = [
        "#FF0000", "#FF0500", "#FF0A00", "#FF0F00", "#FF1400", "#FF1A00", "#FF1F00", "#FF2400", "#FF2900", "#FF2E00",
        "#FF3300", "#FF3800", "#FF3D00", "#FF4200", "#FF4700", "#FF4D00", "#FF5200", "#FF5700", "#FF5C00", "#FF6100",
        "#FF6600", "#FF6B00", "#FF7000", "#FF7500", "#FF7A00", "#FF8000", "#FF8500", "#FF8A00", "#FF8F00", "#FF9400",
        "#FF9900", "#FF9E00", "#FFA300", "#FFA800", "#FFAD00", "#FFB300", "#FFB800", "#FFBD00", "#FFC200", "#FFC700",
        "#FFCC00", "#FFD100", "#FFD600", "#FFDB00", "#FFE000", "#FFE600", "#FFEB00", "#FFF000", "#FFF500", "#FFFA00",
        /*"#FFFF00",
        "#FFFF00",*/ "#FAFC00", "#F5FA00", "#F0F700", "#EBF500", "#E6F200", "#E0F000", "#DBED00", "#D6EB00", "#D1E800",
        "#CCE600", "#C7E300", "#C2E100", "#BDDE00", "#B8DB00", "#B3D900", "#ADD600", "#A8D400", "#A3D100", "#9ECF00",
        "#99CC00", "#94CA00", "#8FC700", "#8AC500", "#85C200", "#80C000", "#7ABD00", "#75BA00", "#70B800", "#6BB500",
        "#66B300", "#61B000", "#5CAE00", "#57AB00", "#52A900", "#4DA600", "#47A400", "#42A100", "#3D9E00", "#389C00",
        "#339900", "#2E9700", "#299400", "#249200", "#1F8F00", "#1A8D00", "#148A00", "#0F8800", "#0A8500", "#058300",
        "#008000"
    ];

    var currentStop = 0.0;
    var breakColorLoop = false;

    stops = [];
    $.each(colors, function(index, color) {
        if (breakColorLoop == true) {
            return;
        }

        currentStop = Math.round((currentStop + step) * 10000) / 10000;;
        stops.push([1-currentStop, color]);

        if (Math.round(currentStop * 100) / 100 == 1.0) {
            breakColorLoop = true;
            return;
        }
    });

    stops.reverse();

    return stops;
};
